<template>
  <div class="app-container">
    <!-- 查询和其他操作 -->
    <div class="filter-container"> 
      <el-select  class="filter-item" v-model="listQuery.cityId" style="width:150px" clearable placeholder="请选择城市" filterable>
        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
          :value="item.id + ''"></el-option>
      </el-select> 
      <el-input
        v-model="listQuery.cusTel"
        clearable
        class="filter-item"
        style="width: 160px;"
        placeholder="请输入用户手机"
      />
      <el-input
        v-model="listQuery.bookno"
        clearable
        class="filter-item"
        style="width: 160px;"
        placeholder="请输入工单号"
      />
      <el-input
        v-model="listQuery.workerName"
        clearable
        class="filter-item"
        style="width: 160px;"
        placeholder="请输入服务者姓名"
      />
      <el-select
        class="filter-item"
        v-model="listQuery.state"
        placeholder="请选择验收状态"
        clearable
      >
        <el-option :value="1" label="未验收" />
        <el-option :value="2" label="已验收" />
      </el-select>
      <el-select
        class="filter-item"
        v-model="listQuery.resultType"
        placeholder="客户验收结果"
        clearable
      >
        <el-option :value="1" label="非常满意" />
        <el-option :value="2" label="基本满意" />
        <el-option :value="3" label="不满意" />
      </el-select>
      <el-date-picker
        v-model="timeArray"
        type="datetimerange"
        class="filter-item"
        range-separator="至"
        start-placeholder="创建开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd HH:mm:ss"
      />

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >查找</el-button
      >
    </div>

    <!-- 查询结果 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="正在查询中。。。"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        label="服务工单号"
        prop="bookno"
        fixed="left"
      />
      <el-table-column
        align="center"
        label="服务地址"
        width="185"
        prop="address"
      />
      <el-table-column
        align="center"
        label="服务时间"
        min-width="120"
        prop="serviceTime"
      />
      <el-table-column align="center" label="客户电话" prop="cusTel" />
      <el-table-column align="center" label="服务者城市" prop="city" >
        <template slot-scope="scope">
          {{ getcityName(scope.row.cityId) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="服务者" prop="workerName" />

      <el-table-column align="center" label="验收结果" prop="resultType">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.resultType == 1">
            非常满意</el-tag
          >
          <el-tag type="success" v-if="scope.row.resultType == 2">
            基本满意</el-tag
          >
          <el-tag type="warning" v-if="scope.row.resultType == 3">
            不满意</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="验收时间"
        :formatter="dateFormatA"
        min-width="150"
        prop="resultAddTime"
      />
      <el-table-column align="center" label="状态" min-width="150" prop="state">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.state == 1"> 未验收</el-tag>
          <el-tag type="success" v-if="scope.row.state == 2"> 已验收</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="创建时间"
        :formatter="dateFormatA"
        min-width="150"
        prop="createTime"
      />

      <el-table-column
        align="center"
        label="操作"
        class-name="small-padding fixed-width"
        fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.pageNo"
      :limit.sync="listQuery.pageSize"
      @pagination="getList"
    />

    <el-dialog
      :visible.sync="preDialogVisible"
      title="预检单详情"
      width="600px"
    >
      <div class="book">
        <div style="border-bottom:0.5px dashed #999">
          <div class="status">
            {{ tempRow.status == 0 ? "未验收" : "已验收" }}
          </div>
          <div class="bookname">工单号：{{ tempRow.bookno }}</div>
          <div class="address">服务地址： {{ tempRow.address }}</div>

          <div class="serviceTime">
            服务时间：{{ timeFMT(tempRow.createTime) }}
          </div>
          <div class="goodsname">服务人员：{{ tempRow.workerName }}</div>
        </div>
        <!-- 预检项目   -->
        <div
          class="content"
          v-for="(item, index1) in preDetail"
          :key="'a-' + index1"
        >
          <div class="category">{{ item.title }}</div>
          <div class="device">
            <template  v-for="(item2, index2) in item.resultList" >
              <span  :key="'b-' + index2"  v-if="item2.checked" class="problem">{{item2.resultName  }} </span>

              <span  :key="'c-' + index2"  v-if="item2.checked&&item2.inputText!=''" class="problem">
                备注：{{item2.resultName  }} 
              </span>
               <div  v-if="item2.checked"
                    v-for="(item3, index3) in item2.uploadImg"
                   :key="'c-' + index3" 
                    class="problemimg"
                > 
                    <el-image
                    class="img"
                    style="width: 100px; height: 100px"
                    :src="item3"
                    fit="contain"
                    :preview-src-list="item2.uploadImg"
                    >
                    </el-image>
                </div>
              
            </template>
          </div>

          
         
        </div>
      </div>
      <center>
        <el-button @click="preDialogVisible = false">关闭</el-button>
      </center>
    </el-dialog>
  </div>
</template>

<script>
import Service from "../../script/api/service";
import Pagination from "@/components/Pagination";
import { formatDate } from "@/utils/date";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import moment from "moment";

export default {
  name: "Pre",
  components: { Pagination },
  filters: {
    filterCity(value) {
      if (value == null || value.length == 0) return "";
      return value.substring(0, 2);
    }
  },
  data() {
    return {
      tempRow: {},
      list: [],
      total: 0,
      listLoading: true,

      cityList:[],
      timeArray: [],
      listQuery: {
        pageNo: 1,
        pageSize: 20,
        cityId:'',
        cusTel: "",
        bookno: "",
        workerName: "",
        state: "",
        resultType: "",
        start: null,
        end: null
      },
      preDialogVisible: false,
      preDetail: [],

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {},
  created() {
    this.getList();
    this.getAllCity();
  },
  methods: {
    getcityName(id){
      let nm='';
      this.cityList.forEach(f=>{
        if(f.id==id){
          nm=f.cityName;
        }
      })
      return nm;
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getList() {
      this.listLoading = true;
      if (this.timeArray && this.timeArray.length === 2) {
        this.listQuery.start = this.timeArray[0];
        this.listQuery.end = this.timeArray[1];
      } else {
        this.listQuery.start = null;
        this.listQuery.end = null;
      }

      Service.$axiosprebjorderList(this.listQuery)
        .then(response => {
          this.list = response.data.data.list;
          this.total = response.data.data.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.total = 0;
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.pageNo = 1;
      this.getList();
    },
    handleDetail(row) {
      this.tempRow = row;
      Service.$axiosprebjorderDetail({ id: row.id }).then(response => {
        this.preDetail = response.data.data;
      });
      this.preDialogVisible = true;
    },
    timeFMT(date) {
      if (date == null || date == "") {
        return null;
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "客户手机",
          "订单编号",
          "下单时间",
          "收货人联系方式",
          "上门地址",
          "城市",
          "上级合伙人",
          "订单状态",
          "支付金额",
          "支付时间"
        ];
        const filterVal = [
          "customer.tel",
          "orderSn",
          "createTime",
          "mobile",
          "address",
          "city",
          "rCustomer.customerName",
          "orderStatus",
          "actualPrice",
          "payTime"
        ];
        var lists = [];
        if (this.list && this.list.length > 0) {
          for (let i = 0; i < this.list.length; i++) {
            var order = this.list[i];
            order.city = this.cityFilter(order.address);
            order.orderStatus = statusMap[order.orderStatus];
            lists.push(order);
          }
          console.info(lists);
        }
        excel.export_json_to_excel2(tHeader, lists, filterVal, "订单");
        this.downloadLoading = false;
      });
    }
  }
};
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.book {
  /* margin: 20px 20px; */
  margin-bottom: 20px;
  /* height: 320px; */
  /* width: 710px; */
  border: 1px solid #999;
  border-radius: 10px;
  display: flex;
  flex-flow: column;
  padding-bottom: 20px;
}

.bookname {
  display: block;
  color: #333;
  line-height: 22px;
  font-size: 25px;
  margin: 20px 20px;
  font-weight: 500;
}

.address {
  display: block;
  color: darkred;
  line-height: 18px;
  font-size: 18px;
  margin: 20px 20px;
}
.serviceTime {
  display: block;
  color: #333;
  line-height: 18px;
  font-size: 18px;
  margin: 20px 20px;
  font-weight: 300;
}
.goodsname {
  color: #333;
  line-height: 18px;
  font-size: 18px;
  margin: 20px 20px;
  font-weight: 300;
}
.status {
  height: 35px;
  float: right;
  margin: 10px;
  background-color: #09afff;
  padding: 10px;
  border-radius: 10px;
  color: #fff;
}

.content {
  margin-top: 20px;
  font-size: 18px;
  line-height: 20px;
  font-weight: 500;
  margin: 20px;
  color: #333;
}
.category {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

.device {
  line-height: 28px;
  font-size: 18px;
  font-weight: 200;
  color: #09afff;
}
.problem {
  display: flex;
  float: left;
  flex-wrap: wrap;
  color: #09afff;
}
.problemimg {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  color: #09afff;
}

.item {
  margin: 5px;
  font-size: 16px;
}

.img {
  margin: 10px;
  width: 80px;
  height: 80px;
}

/*-------------- */

.detail-container {
  width: 80%;
  padding: 20px 20px 20px 20px;
  margin: 20px auto;
}

.operate-container {
  background: #f2f6fc;
  height: 80px;
  margin: -20px -20px 0;
  line-height: 80px;
}

.operate-button-container {
  float: right;
  margin-right: 20px;
}

.table-layout {
  margin-top: 20px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  height: 60px;
  line-height: 20px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  white-space: pre-wrap;
  /* overflow: hidden; */
}

.table-cell-title {
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  background: #f2f6fc;
  text-align: center;
  font-size: 14px;
  color: #303133;
}
.el-table th.gutter {
  display: table-cell !important;
}
.color-danger {
  color: #f56c6c;
  font-size: 18px;
}
/* .img-wrapper img{
    width:100px;
    height: 100px;
    object-fit: contain;
  } */
</style>
